import type { GlobalContext } from '~/Features/Configuration/GlobalContext.csharp';
import { CheckboxVariant } from '~/Partials/Checkbox/CheckboxVariant.csharp';
import { KristianiaLogoVariant } from '~/Partials/Header/Settings/KristianiaLogoVariant.csharp';
import { mapToLanguageCode } from '~/Partials/Locale/Locale';

export class GlobalContextProvider {
    private static getProperty<TType>(selector: (configuration: GlobalContext) => TType): TType | undefined {
        // GLOBAL_CONTEXT can be null when rendering single property inside inline edit view in Episerver.
        // But we don't have to pay too much attention to it because page re-renders within page content afterward.
        if (typeof GLOBAL_CONTEXT === 'undefined' || GLOBAL_CONTEXT === null) {
            return undefined;
        }

        return selector(GLOBAL_CONTEXT);
    }

    static getLogoSettings() {
        return (
            GlobalContextProvider.getProperty(config => config.logoSettings) ?? {
                headerVariant: KristianiaLogoVariant.Default,
                defaultAltText: 'Kristiania logo',
            }
        );
    }

    static getFrontendSettings() {
        return (
            GlobalContextProvider.getProperty(config => config.frontendSettings) ?? {
                checkboxVariant: CheckboxVariant.Default,
            }
        );
    }

    static getContentLanguage() {
        return mapToLanguageCode(GlobalContextProvider.getProperty(config => config.contentLanguage) ?? 'no');
    }

    static getMyPageGlobalConfiguration() {
        return GlobalContextProvider.getProperty(config => config.myPageGlobalConfiguration);
    }

    static isSpaPage() {
        return !!GlobalContextProvider.getMyPageGlobalConfiguration();
    }

    static isModernPage() {
        return !!GlobalContextProvider.getProperty(config => config.isModernPage);
    }
}
